export default __webpack_public_path__ + "static/media/himanshu.fe64af07.png";